import { render, staticRenderFns } from "./empty_cart.vue?vue&type=template&id=121bad9f&scoped=true"
import script from "./empty_cart.vue?vue&type=script&lang=js"
export * from "./empty_cart.vue?vue&type=script&lang=js"
import style0 from "./empty_cart.vue?vue&type=style&index=0&id=121bad9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121bad9f",
  null
  
)

export default component.exports